import { hot } from 'react-hot-loader/root';
import React from 'react';
import PropTypes from 'prop-types';

import PageWrapper from '../design-system/PageWrapper';
import IconPageSection from '../design-system/IconPageSection';
import Container from '../design-system/Containers';
import DossierAd from '../components/DossierAd';

const DossierAdPage = ({
  phrases,
  dashboardPath,
  previewLink,
  buyBtnPath,
  priceCents,
}) => (
  <PageWrapper tallNav bgDark>
    <IconPageSection>
      <Container dossier>
        <DossierAd
          dashboardPath={dashboardPath}
          buyBtnPath={buyBtnPath}
          previewLink={previewLink}
          phrases={phrases}
          priceCents={priceCents}
        />
      </Container>
    </IconPageSection>
  </PageWrapper>
);

DossierAdPage.propTypes = {
  dashboardPath: PropTypes.string.isRequired,
  buyBtnPath: PropTypes.string.isRequired,
  previewLink: PropTypes.string.isRequired,
  phrases: PropTypes.exact({
    title: PropTypes.string,
    pitch: PropTypes.string,
    buyButtonLabel: PropTypes.string,
    previewButtonLabel: PropTypes.string,
    notInterested: PropTypes.string,
    online: PropTypes.string,
    modalTitle: PropTypes.string,
    modalDescription: PropTypes.string,
    modalButtonLabel: PropTypes.string,
  }).isRequired,
  priceCents: PropTypes.number.isRequired,
};

export default hot(DossierAdPage);
